import { ref } from 'vue';
import { type Mutation, type Query } from '@/graphql/generated';

export type PageErrorKey = keyof Query | keyof Mutation;

const pageErrorKey = ref<PageErrorKey>();

export const usePageErrorStore = () => {
  const setPageErrorKey = (key: PageErrorKey | undefined) => {
    pageErrorKey.value = key;
  };

  return {
    pageErrorKey,
    setPageErrorKey,
  };
};
